module.exports = __webpack_public_path__ + "img/betsize_btn.573dee62.png";